import { render } from "./LineChartD.vue?vue&type=template&id=604ffdd6&scoped=true"
import script from "./LineChartD.vue?vue&type=script&lang=ts"
export * from "./LineChartD.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-604ffdd6"

export default script